<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center align-items-center animated fadeIn flex-column">
        <b-col sm="12" md="8" lg="6">
          <ActivateAccountForm />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import ActivateAccountForm from "@/modules/auth/components/ActivateAccountForm.vue";
</script>
